export default "__VITE_ASSET__DvY7g7CL__"